var BaseViews = require('../../base');
require('./cart-total-weight/cart-total-weight.scss');

var CartTotalWeight = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-total-weight',
    template: require('./cart-total-weight/cart-total-weight.html'),
    initialize: function(options) {
        var self = this;
        var defaults = {
          theme: 'light',
          weight: 0,
          hidden: false,
          weightError: false,
          messagePrefix: 'Cart total cannabis equivalent product weight: ',
          messageSuffix: ' grams',
          subMessageDefault: 'Maximum of 30 grams of cannabis equivalent per an order',
          errorMessage: 'Your order exceeds the maximum of 30 grams of cannabis equivalent per an order.'
        };

        this.options = _.defaults(
            options || {},
            defaults
        );

        if (this.options.errorMessage == null) {
          this.options.errorMessage = defaults.errorMessage;
        }
    },
    serializeData: function () {
      return {
        subMessage: this.options.subMessageDefault
      }
    },
    updateMessage: function (weight) {
      this.ui.totalWeightMessage.html(this.options.messagePrefix + weight.totalWeight + this.options.messageSuffix);

      if (this.options.weightError || weight.error) {
        if (!this.$el.hasClass('cart-total-error-message')) {
          this.$el.addClass('cart-total-error-message');
        }
        this.ui.subMessage.html(this.options.errorMessage);
      } else {
        if (this.$el.hasClass('cart-total-error-message')) {
          this.$el.removeClass('cart-total-error-message');
        }
        this.ui.subMessage.html(this.options.subMessageDefault);
      }
    },
    ui: {
      totalWeightMessage: '.fmcy-cart-total-weight-inner',
      subMessage: '.fmcy-cart-total-weight-sub-message-text'
    },
    hide: function () {
      this.$el.hide();
    },
    show: function () {
      this.$el.show();
    },
    onRender: function() {
      var self = this;
      this.updateMessage(this.options.weight);
      if (this.options.hidden) {
        this.$el.hide();
      }
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});

module.exports = CartTotalWeight;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-review/cart-total-weight.js
 **/